module.exports = __webpack_public_path__ + "static/media/14.f0454fb7.jpg";